import React from 'react';
import { wrapFunctionalComponent } from 'utils/framework';
import {
    Box, Divider, Text, Flex
} from 'components/ui';
import { colors } from 'style/config';
import Paypal from 'components/FrictionlessCheckout/PaymentReleaseFour/PaymentMethodList/Paypal/Paypal';
import Klarna from 'components/FrictionlessCheckout/PaymentReleaseFour/PaymentMethodList/Klarna/Klarna';
import AfterPay from 'components/FrictionlessCheckout/PaymentReleaseFour/PaymentMethodList/AfterPay/AfterPay';

const AlternatePaymentButtons = ({
    isAfterpayEnabledForThisOrder,
    isKlarnaEnabledForThisOrder,
    isPayPalEnabled,
    isPayPalPayLaterEligible,
    isAfterpayEnabledForThisProfile,
    installmentValue,
    localization
}) => {
    // PayPal button only shows when enabled AND order >= $30 (isPayPalPayLaterEligible)
    // For orders < $30, PayPal is hidden on L1 (existing users with saved cards)
    const showPayPal = isPayPalEnabled && isPayPalPayLaterEligible;

    // Show installment text if any installment payment method is available
    const showInstallmentText = isPayPalPayLaterEligible || isKlarnaEnabledForThisOrder || isAfterpayEnabledForThisOrder;

    //will be implemented in other ticket
    const handlePayPalClick = () => {
        //console.log('handlePayPalClick');
    };

    const handleKlarnaClick = () => {
        //console.log('handleKlarnaClick');
    };

    const handleAfterPayClick = () => {
        //console.log('handleAfterPayClick');
    };

    return (
        <Box>
            <Divider marginY={4} />
            <Box paddingX={5}>
                {showInstallmentText && (
                    <Text
                        is='p'
                        color={colors.gray}
                        marginBottom={1}
                        fontSize='sm'
                    >
                        {`${localization.orPayInFour} ${installmentValue}`}
                    </Text>
                )}

                {/* Payment buttons */}
                <Flex
                    gap={2}
                    marginBottom={4}
                >
                    <Paypal
                        isPayPalEnabled={showPayPal}
                        handlePaymentClick={handlePayPalClick}
                        height={32}
                        width={98}
                        imageHeight='16px'
                    />
                    <Klarna
                        isKlarnaEnabledForThisOrder={isKlarnaEnabledForThisOrder}
                        handlePaymentClick={handleKlarnaClick}
                        height={32}
                        width={showPayPal ? 98 : 151}
                        imageHeight='16px'
                    />
                    <AfterPay
                        isAfterpayEnabledForThisOrder={isAfterpayEnabledForThisOrder}
                        isAfterpayEnabledForThisProfile={isAfterpayEnabledForThisProfile}
                        handlePaymentClick={handleAfterPayClick}
                        height={32}
                        width={showPayPal ? 98 : 151}
                        imageHeight='16px'
                    />
                </Flex>
            </Box>
        </Box>
    );
};

export default wrapFunctionalComponent(AlternatePaymentButtons, 'AlternatePaymentButtons');
